// 发现
const DiscoverHome = r => require.ensure(
  [],
  () => r(require('@/components/discover/home/index')),
  'DiscoverHome'
)
// 专区
const DiscoverZone = r => require.ensure(
  [],
  () => r(require('@/components/discover/zone/zone')),
  'DiscoverZone'
)

export default [
  // 发现首页
  {
    path: '/discoverHome',
    name: 'DiscoverHome',
    component: DiscoverHome
  },
  // 发现专区
  {
    path: '/discoverZone',
    name: 'DiscoverZone',
    component: DiscoverZone
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/discover.js